import type { RechercheDossierQueryDTO, RechercheResultDTO } from '@/features/api/extranet/dto/Dossier/Recherche'
import { buildRechercheStore } from '../storeRechercheBuilder'

export const useRechercheDossierStore = buildRechercheStore<RechercheDossierQueryDTO, RechercheResultDTO>({
  storeName: 'rechercheDossierStore',
  apiPath: '/dossiers',
})

